export const OPEN_WORK_TAB_AREA_MARK_TONES = ['purple', 'green', 'blue', 'ochre'] as const;

export type OpenWorkTabAreaMarkTone = (typeof OPEN_WORK_TAB_AREA_MARK_TONES)[number];

export interface OpenWorkTabAreaMark {
  label: string;
  monogram: string;
  tone: OpenWorkTabAreaMarkTone;
}

export function isOpenWorkTabAreaMark(value: unknown): value is OpenWorkTabAreaMark {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.label === 'string' &&
    Boolean(candidate.label.trim()) &&
    typeof candidate.monogram === 'string' &&
    /^[A-Z]{2}$/.test(candidate.monogram) &&
    OPEN_WORK_TAB_AREA_MARK_TONES.includes(candidate.tone as OpenWorkTabAreaMarkTone) &&
    Object.keys(candidate).every((key) => ['label', 'monogram', 'tone'].includes(key))
  );
}
